import {
  setAnimateFeatureTable_actionType,
  setEditableFeature_actionType,
  setEditableLayer_actionType,
  setEditorAddPointActive_actionType,
  setEditorDrawActive_actionType,
  setEditorUpdateType_actionType,
  setReportedFeature_actionType,
  setReports_actionType,
  setReportsLayer_actionType,
  setReportsLayerMap_actionType,
  setShowReportsPanel_actionType,
  updateReportsLayerMap_actionType,
} from "../constants";

export const setAnimateFeatureTable = (payload) => ({
  type: setAnimateFeatureTable_actionType,
  payload,
});

export const setEditableFeature = (payload) => ({
  type: setEditableFeature_actionType,
  payload,
});

export const setEditableLayer = (payload) => ({
  type: setEditableLayer_actionType,
  payload,
});

export const setEditorDrawActive = (payload) => ({
  type: setEditorDrawActive_actionType,
  payload,
});

export const setEditorAddPointActive = (payload) => ({
  type: setEditorAddPointActive_actionType,
  payload,
});

export const setEditorUpdateType = (payload) => ({
  type: setEditorUpdateType_actionType,
  payload,
});

export const setReportsLayerMap = (payload) => ({
  type: setReportsLayerMap_actionType,
  payload,
});

export const setReports = (payload) => ({
  type: setReports_actionType,
  payload,
});

export const setReportsLayer = (payload) => ({
  type: setReportsLayer_actionType,
  payload,
});

export const updateReportsLayerMap = (payload) => ({
  type: updateReportsLayerMap_actionType,
  payload,
});

export const setReportedFeature = (payload) => ({
  type: setReportedFeature_actionType,
  payload,
});

export const setShowReportsPanel = (payload) => ({
  type: setShowReportsPanel_actionType,
  payload,
});
